import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import pt from './locales/pt-br.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    uai: { translation: pt },
  },
  lng: 'en', // idioma padrão
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;